import React from 'react'
import styled from 'styled-components'
import { layout, space, position } from 'styled-system'
import { Parallax } from 'react-scroll-parallax'
import { scrollIntoView, pxToRem } from 'utils/helpers'
import { COLORS } from 'config/constants'
import { Flex, Box } from 'components/atoms/Layout'
import { H4, H2, Text } from 'components/atoms/Typography'
import Button from 'components/atoms/Button'
import { MENU_HEIGHT } from 'routes/components/pages/GenericPage/Header'
import Container from 'components/atoms/Container'
import clouds from 'assets/svg/hero/clouds.svg'
import houseWithSurroundings from 'assets/svg/hero/house-with-surroundings.svg'
import woman from 'assets/svg/hero/woman.svg'

const FitScreen = styled.div`
  position: relative;
  display: flex;
  background-color: red;
  background-color: ${COLORS.EVERLASTING_ICE};
  height: calc(100vh - ${MENU_HEIGHT});
  min-height: 600px;
  overflow: hidden;
`

const ParallaxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: url("${clouds}") center / contain no-repeat;
  background-attachment: fixed;
`

const StyledParallax = styled(Parallax)`
  ${layout}
  ${space}
  ${position}
`

const Hero = () => (
  <FitScreen>
    <ParallaxWrapper>
      <StyledParallax y={['0px', '100px']} width="100%" mx="auto">
        <Container as={Flex} flex="1 1 0" minHeight="0" data-aos="fade-up">
          <Box m="auto" textAlign="center">
            <H4 as="h1" color="text" fontWeight="normal">
              Buy your new home instead of renting it.
            </H4>
            <H2 fontSize={{ mobile: 'h3', tablet: 'h2', desktop: 'h1' }}>
              <Text
                fontSize="inherit"
                color="inherit"
                fontWeight="normal"
                as="span"
              >
                With
              </Text>{' '}
              No Down Payment
            </H2>
            <Flex justifyContent="center">
              <Button.Filled
                onClick={() => scrollIntoView('rent-form')}
                mt="l"
                fontSize="m"
              >
                WHAT CAN I AFFORD?
              </Button.Filled>
            </Flex>
          </Box>
        </Container>
      </StyledParallax>
      <StyledParallax y={[0, 20]} position="absolute" bottom="0" width="100%">
        <Box
          height="40vh"
          minHeight={pxToRem(300)}
          backgroundImage={`url("${houseWithSurroundings}")`}
          backgroundSize="cover"
          backgroundPosition="center bottom"
          backgroundRepeat="no-repeat"
        />
      </StyledParallax>
      <StyledParallax y={[50, 0]} position="absolute" bottom="0" width="100%">
        <Box
          height="50vh"
          backgroundImage={`url("${woman}")`}
          backgroundSize="contain"
          backgroundPosition="75%"
          backgroundRepeat="no-repeat"
        />
      </StyledParallax>
    </ParallaxWrapper>
  </FitScreen>
)

export default Hero
